import React from 'react';
import Section from './section';
import config from 'config/config';
import i18n from 'src/utils/translate';
import { numberFormat } from 'src/utils/string';
import { connect } from 'react-redux';
import { recalculateNumbers } from 'src/modules/home/actions';
import LazyImage from 'src/utils/lazyImage';

class Last30DaysSection extends React.Component {
  componentDidMount() {
    setInterval(() => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'recalculateNumbers' does not exist on ty... Remove this comment to see the full error message
      this.props.recalculateNumbers();
    }, 1000);
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'numbers' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { numbers } = this.props;
    return (
      <Section className="home__last-30" withColumns={true}>
        <div>
          <div>
            <LazyImage
              alt="HealthUnlocked"
              classnames="home__logo"
              src={`${config.cdn.static}img/healthunlocked-logo-green.png`}
            />
          </div>
          <div className="home__stats-description">{i18n.t('in the last 30 days')}</div>
        </div>
        <div className="home__numbers">
          <div className="home__stats">
            <div className="home__stats-number">{numberFormat(numbers.peopleCount)}</div>
            <div className="home__stats-subtitle">people</div>
          </div>
          <div className="home__stats">
            <div className="home__stats-number">{numberFormat(numbers.interactionCount)}</div>
            <div  className="home__stats-subtitle">interactions</div>
          </div>
        </div>
      </Section>
    );
  }
}

const mapStateToProps = (state) => ({
  numbers: state.pages.home.numbers,
});

const actions = {
  recalculateNumbers,
};

export default connect(mapStateToProps, actions)(Last30DaysSection);
